(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["five-meal-system"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (
        !root ||
        root.dataset.animationReady === 'true'
      ) {
        return;
      }

      root.dataset.animationReady = 'true';

      root.classList.add(
        'five-meal--initialized'
      );

      if (
        !root.classList.contains(
          'five-meal--animate'
        ) ||
        window
          .matchMedia(
            '(prefers-reduced-motion: reduce)'
          )
          .matches
      ) {
        root.classList.add('is-visible');
        return;
      }

      let replayTimer;

      const play = () => {
        window.clearTimeout(replayTimer);

        root.classList.remove('is-visible');
        void root.offsetWidth;
        root.classList.add('is-visible');

        if (root.dataset.loop === 'true') {
          const cycleDuration =
            Number(
              root.dataset.cycleDuration
            ) || 5000;

          replayTimer =
            window.setTimeout(
              play,
              cycleDuration
            );
        }
      };

      const observer =
        new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) {
                return;
              }

              play();
              observer.disconnect();
            });
          },
          {
            threshold: 0.28
          }
        );

      observer.observe(root);
    };

    const initializeAll = (
      scope = document
    ) => {
      scope
        .querySelectorAll(
          '[data-five-meal-section]'
        )
        .forEach(initialize);
    };

    if (
      document.readyState === 'loading'
    ) {
      document.addEventListener(
        'DOMContentLoaded',
        () => initializeAll()
      );
    } else {
      initializeAll();
    }

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        initializeAll(event.target);
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["food-tray-pop-up"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (
        !root ||
        root.dataset.animationReady === 'true'
      ) {
        return;
      }

      root.dataset.animationReady = 'true';

      root.classList.add(
        'five-meal--initialized'
      );

      if (
        !root.classList.contains(
          'five-meal--animate'
        ) ||
        window
          .matchMedia(
            '(prefers-reduced-motion: reduce)'
          )
          .matches
      ) {
        root.classList.add('is-visible');
        return;
      }

      let replayTimer;

      const play = () => {
        window.clearTimeout(replayTimer);

        root.classList.remove('is-visible');
        void root.offsetWidth;
        root.classList.add('is-visible');

        if (root.dataset.loop === 'true') {
          const cycleDuration =
            Number(
              root.dataset.cycleDuration
            ) || 5000;

          replayTimer =
            window.setTimeout(
              play,
              cycleDuration
            );
        }
      };

      const observer =
        new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) {
                return;
              }

              play();
              observer.disconnect();
            });
          },
          {
            threshold: 0.28
          }
        );

      observer.observe(root);
    };

    const initializeAll = (
      scope = document
    ) => {
      scope
        .querySelectorAll(
          '[data-five-meal-section]'
        )
        .forEach(initialize);
    };

    if (
      document.readyState === 'loading'
    ) {
      document.addEventListener(
        'DOMContentLoaded',
        () => initializeAll()
      );
    } else {
      initializeAll();
    }

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        initializeAll(event.target);
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["furdear-countdown"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('furdear-countdown')) {
 customElements.define('furdear-countdown', class extends HTMLElement {
  readTime(prefix) {
   const read = key => Number(this.getAttribute('data-' + prefix + '-' + key));
   const y=read('year'), m=read('month'), d=read('day'), h=read('hour'), n=read('minute');
   const date=new Date(Date.UTC(y,m-1,d,h,n));
   if(date.getUTCFullYear()!==y || date.getUTCMonth()!==m-1 || date.getUTCDate()!==d || h<0 || h>23 || n<0 || n>59) return NaN;
   const match=/^([+-])(\d{2}):(\d{2})$/.exec(this.dataset.offset || '');
   if(!match) return NaN;
   const offset=(Number(match[2])*60+Number(match[3]))*(match[1]==='-'?-1:1);
   return date.getTime()-offset*60000;
  }
  connectedCallback() {
   this.frame=requestAnimationFrame(()=>this.initialize());
  }
  static get observedAttributes() { return ['data-start-year','data-start-month','data-start-day','data-start-hour','data-start-minute','data-finish-year','data-finish-month','data-finish-day','data-finish-hour','data-finish-minute','data-offset']; }
  attributeChangedCallback() {
   if(this.isConnected) { cancelAnimationFrame(this.frame); this.frame=requestAnimationFrame(()=>this.initialize()); }
  }
  matchHeading() {
   if(this.dataset.matchHeading !== 'true') {this.fitHeading();return;}
   const own=this.querySelector('.fd-heading');
   let next=this.closest('.shopify-section')?.nextElementSibling;
   while(next) {
    const other=next.querySelector('h2');
    if(other && own) {
     const style=getComputedStyle(other);
     ['fontFamily','fontSize','fontWeight','fontStyle','lineHeight','letterSpacing'].forEach(key=>{own.style[key]=style[key];});
     break;
    }
    next=next.nextElementSibling;
   }
  }
  fitHeading() {
   const title=this.querySelector('.fd-heading');
   if(!title) return;
   if(this.dataset.singleHeading==='true' && window.innerWidth>=1200) {
    title.style.whiteSpace='nowrap';
    title.style.overflowWrap='normal';
    if(this.dataset.matchHeading!=='true') title.style.fontSize='';
    let size=parseFloat(getComputedStyle(title).fontSize);
    while(title.scrollWidth>title.clientWidth && size>14) {size-=0.5;title.style.fontSize=size+'px';}
   } else {
    title.style.whiteSpace='';title.style.overflowWrap='';
    if(this.dataset.matchHeading!=='true') title.style.fontSize='';
   }
  }
  initialize() {
   clearInterval(this.interval);
   if(!this.querySelector('.fd-timer') || !this.querySelector('.fd-time-error')) return;
   this.matchHeading();this.fitHeading();
   if(!this.onResize) {this.onResize=()=>{this.matchHeading();this.fitHeading();};window.addEventListener('resize',this.onResize);}

   this.start=this.readTime('start'); this.finish=this.readTime('finish');
   this.valid=Number.isFinite(this.start)&&Number.isFinite(this.finish)&&this.finish>this.start;
   this.tick();
   if(this.valid && this.finish>Date.now()) this.interval=setInterval(()=>this.tick(),1000);
  }
  disconnectedCallback() { clearInterval(this.interval); cancelAnimationFrame(this.frame); if(this.onResize) window.removeEventListener('resize',this.onResize); this.onResize=null; }
  tick() {
   const editor=Boolean(window.Shopify?.designMode), now=Date.now();
   const before=this.valid && now<this.start, expired=this.valid && now>=this.finish;
   this.hidden=!editor && (!this.valid || (before && this.dataset.before==='true') || (expired && this.dataset.hide==='true'));
   this.querySelector('.fd-time-error').hidden=this.valid || !editor;

   const message=this.querySelector('.fd-expired');
   message.hidden=!expired;
   this.querySelector('.fd-timer').hidden=expired && Boolean(message.textContent.trim());
   const target=this.finish;
   const t=this.valid?Math.max(0,Math.ceil((target-now)/1000)):0;
   const values={days:Math.floor(t/86400),hours:Math.floor(t%86400/3600),minutes:Math.floor(t%3600/60),seconds:t%60};
   Object.entries(values).forEach(([key,value])=>{this.querySelector('[data-unit="'+key+'"]').textContent=String(value).padStart(2,'0');});
   if(expired) clearInterval(this.interval);
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('review-slider')) {
    customElements.define(
      'review-slider',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-review-track]');
          this.previousButton = this.querySelector('[data-review-prev]');
          this.nextButton = this.querySelector('[data-review-next]');

          if (
            !this.track ||
            !this.previousButton ||
            !this.nextButton
          ) {
            return;
          }

          this.previousButton.addEventListener(
            'click',
            () => this.move(-1)
          );

          this.nextButton.addEventListener(
            'click',
            () => this.move(1)
          );

          this.track.addEventListener(
            'scroll',
            () => this.update(),
            { passive: true }
          );

          this.resizeObserver = new ResizeObserver(
            () => this.update()
          );

          this.resizeObserver.observe(this.track);
          this.update();
        }

        disconnectedCallback() {
          if (this.resizeObserver) {
            this.resizeObserver.disconnect();
          }
        }

        move(direction) {
          const card = this.track.querySelector('.europa-review');

          if (!card) {
            return;
          }

          const gap =
            parseFloat(getComputedStyle(this.track).gap) || 0;

          this.track.scrollBy({
            left: direction * (card.offsetWidth + gap),
            behavior: 'smooth'
          });
        }

        update() {
          const overflow =
            this.track.scrollWidth >
            this.track.clientWidth + 2;

          const end =
            this.track.scrollWidth -
            this.track.clientWidth;

          const mobile = window
            .matchMedia('(max-width: 749px)')
            .matches;

          this
            .closest('.europa-reviews')
            .classList.toggle('has-overflow', overflow);

          this.previousButton.disabled =
            !overflow || this.track.scrollLeft <= 2;

          this.nextButton.disabled =
            !overflow ||
            this.track.scrollLeft >= end - 2;

          this.previousButton.hidden =
            !mobile && !overflow;

          this.nextButton.hidden =
            !mobile && !overflow;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
